import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: {},
};

export default function promotorsAddReducer(state = initialState, action) {
  switch (action.type) {
    case types.ADD_PROMOTOR_INIT:
      return { ...state, error: null, isLoading: true };

    case types.ADD_PROMOTOR_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.ADD_PROMOTOR_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
